import { useLayoutEffect } from 'react';

export default (autoSwitchTheme, theme, setTheme) => {
  // Layout effect: resolve the system theme before the browser paints, so the
  // first frame (e.g. the boot logo) never flashes the wrong color scheme.
  useLayoutEffect(() => {
    if (!autoSwitchTheme) {
      return () => {};
    }

    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e) => setTheme(e.matches ? 'dark' : 'light');
    mediaQuery.addEventListener('change', handleChange);
    handleChange(mediaQuery);
    return () => mediaQuery.removeEventListener('change', handleChange);
    // The theme is a dependency too: a stored one is resolved again, not kept.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoSwitchTheme, theme]);
};
